export default (state, { payload }) => ({
    ...state,
    modifierKeys: state.modifierKeys.includes(payload)
        ? [...state.modifierKeys]
        : [...state.modifierKeys, payload],
});
